import React from 'react';
import { Clock3Icon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { Badge } from '../Badge';
import { CtaButton } from '../CtaButton';
import { Logo } from '../Logo';
import { IMAGES } from '../../lib/content';
const STATS = [{
  value: '4.9',
  label: 'Avg patient rating',
  star: true
}, {
  value: '250+',
  label: 'Smiles transformed',
  star: false
}, {
  value: '12 years',
  label: 'Premium full-arch experience',
  star: false
}];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-58" data-mp="qvdtav0gtkyw">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-59" data-mp="qtj77ddgjmt8">
        <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-[#A9DFE9]/40 blur-3xl" data-id="element-60" data-mp="vmvwlppynxn1" />
        <div className="absolute top-1/2 -left-32 h-80 w-80 rounded-full bg-[#26B3CA]/15 blur-3xl" data-id="element-61" data-mp="10kxg2bratyz1" />
      </div>

      <div className="relative mx-auto flex max-w-6xl items-center justify-between px-6 py-6" data-id="element-62" data-mp="15ifcx3s1knqo">
        <Logo size="md" aria-label="Pler Smile home" data-id="element-63" data-mp="1ajuycwy4sw9l" />
        <div className="hidden items-center gap-2 text-sm font-semibold text-[#1F6E7B] sm:flex" data-id="element-64" data-mp="9o2r3owkawon">
          <ShieldCheckIcon size={16} data-id="element-65" data-mp="4ogdhectnefb" />
          Dadeland, Kendall, Miami
        </div>
      </div>

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 pb-16 pt-6 lg:grid-cols-2 lg:pb-24 lg:pt-10" data-id="element-66" data-mp="3vu9499yc40fq">
        <div className="flex flex-col" data-id="element-67" data-mp="3rv8nry3bx9vw">
          <div className="mb-6 flex flex-wrap gap-2" data-id="element-68" data-mp="se0zk649urst">
            <Badge variant="aqua" size="sm" className="landing-badge" data-id="element-69" data-mp="sdsh7ypdqua8">All-on-X Dental Implants</Badge>
            <Badge variant="sky" size="sm" className="landing-badge" data-id="element-70" data-mp="nfzfbhv40mfr">Pler Smile Dadeland</Badge>
            <Badge variant="outline" size="sm" className="landing-badge" data-id="element-71" data-mp="imxu6s4b7qnq">5-Day Smile Experience</Badge>
          </div>

          <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-[#1A1A2E] px-4 py-2 text-sm font-semibold text-white" data-id="element-72" data-mp="ekt3o295ra5b">
            <Clock3Icon size={16} className="text-[#A9DFE9]" data-id="element-73" data-mp="16dtl7n0xyhtx" />
            Only 3 clinical openings remain this month
          </div>

          <h1 className="text-4xl font-bold leading-[1.05] tracking-tight text-[#1A1A2E] md:text-5xl lg:text-6xl" data-id="element-74" data-mp="30mfitw3qxzgr">
            When did smiling become something you avoid?
            <span className="mt-2 block text-[#1F6E7B]" data-id="element-75" data-mp="2qwvwuhkqlpho">5 days in Miami and your smile comes back!!</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#1A1A2E]/80" data-id="element-76" data-mp="2vtmevag3qv5q">
            Complete All-on-X surgery with 3D facial design, four hotel nights, and airport transportation included. {' '}
            <span className="font-bold text-[#1A1A2E]" data-id="element-77" data-mp="2mw3n7n7ydikv">Your final zirconia smile is waiting</span>.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-78" data-mp="27zcozha0mcwu">
            <CtaButton data-id="element-79" data-mp="2cwuxx7o18s4u" />
          </div>

          <dl className="mt-8 grid grid-cols-3 rounded-2xl bg-[#A9DFE9]/20 px-2 py-5 text-center sm:px-4" data-id="element-80" data-mp="65vhcdlvxc23">
            {STATS.map((stat, index) => <div key={stat.label} className={index > 0 ? 'border-l border-[#1A1A2E]/15 px-2 sm:px-4' : 'px-2 sm:px-4'} data-id="element-81" data-mp="b3x356ap3ph9" data-mpi={index}>
                <dd className="flex items-center justify-center gap-1 text-2xl font-bold tracking-tight text-[#1A1A2E] sm:text-3xl" data-id="element-82" data-mp="1vnk4cxqanv65">
                  {stat.value}
                  {stat.star ? <StarIcon size={20} className="fill-[#26B3CA] text-[#26B3CA]" aria-hidden="true" data-id="element-83" data-mp="25dvex34hh2m0" /> : null}
                </dd>
                <dt className="mt-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-[#1A1A2E]/65 sm:text-xs" data-id="element-84" data-mp="20kslqw3mbv6c">{stat.label}</dt>
              </div>)}
          </dl>
        </div>

        <div className="relative" data-id="element-85" data-mp="2abdg27c9edjg">
          <div className="overflow-hidden rounded-[2rem] shadow-soft ring-1 ring-[#A9DFE9]/60" data-id="element-86" data-mp="2ae9hw6r89md6">
            {/* TODO-IMAGE: replace with real onsite photo; consent on file with admin team */}
            <img src={IMAGES.hero} alt="Patient smiling confidently after her All-on-X treatment at Pler Smile Dadeland" className="h-full w-full object-cover" loading="eager" data-id="element-87" data-mp="2jas6j6sfeo3y" />
          </div>
          <div className="absolute -bottom-5 -left-5 hidden rounded-2xl bg-white px-5 py-4 shadow-soft ring-1 ring-[#A9DFE9]/60 sm:block" data-id="element-88" data-mp="p0olcs0oq0gd">
            <div className="text-2xl font-bold text-[#1F6E7B]" data-id="element-89" data-mp="veastdeo8xhx">5 days</div>
            <div className="text-xs font-medium uppercase tracking-wide text-[#1A1A2E]/70" data-id="element-90" data-mp="10dx7lra5elsu">to your final smile</div>
          </div>
        </div>
      </div>
    </section>;
}